var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "dashboard-ecommerce" } },
    [
      _c(
        "b-row",
        { staticClass: "match-height" },
        [
          _c(
            "b-col",
            { attrs: { xl: "3", md: "6" } },
            [
              _c("ecommerce-earnings-chart", {
                attrs: { data: _vm.data.earningsChart },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { xl: "9", md: "6" } },
            [
              _c("ecommerce-statistics", {
                attrs: { data: _vm.data.statisticsItems },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "match-height" },
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-row",
                { staticClass: "match-height" },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "12", md: "6", cols: "12" } },
                    [
                      _c("ecommerce-order-chart", {
                        attrs: { data: _vm.data.statisticsOrder },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "12", md: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "6", md: "3", cols: "6" } },
                            [
                              _c("LeadsChartVue", {
                                attrs: { data: _vm.data.statisticsOrder },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "6", md: "3", cols: "6" } },
                            [
                              _c("ClientsChartVue", {
                                attrs: { data: _vm.data.statisticsProfit },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { lg: "8" } },
            [
              !_vm.loading
                ? _c("ChartSales", {
                    attrs: {
                      sales: _vm.salesOrderList,
                      totalSales: _vm.totalSalesAmount,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "match-height" },
        [
          _c(
            "b-col",
            { attrs: { lg: "8" } },
            [
              !_vm.loading
                ? _c("SalesTable", { attrs: { sales: _vm.salesOrderList } })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { lg: "4", md: "6" } },
            [
              _c("ecommerce-goal-overview", {
                attrs: { data: _vm.data.goalOverview },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }